import * as React from 'react';
import { useFormikContext } from 'formik';

/**
 * Create a mutable ref object that determines whether the current form requires confirmation
 *  before canceling.
 */
const useConfirmationRequiredRef = () => {
  const { dirty } = useFormikContext();

  const confirmationRequired = React.useRef(dirty);

  React.useEffect(() => {
    confirmationRequired.current = dirty;
  }, [dirty]);

  return confirmationRequired;
};

export const useBeforeUnloadConfirmation = (ignoreDirty?: boolean) => {
  const confirmationRequired = useConfirmationRequiredRef();

  const confirmReload = React.useCallback(
    (e: BeforeUnloadEvent) => {
      if (confirmationRequired.current || ignoreDirty) {
        // Cancel the event
        // If you prevent default behavior in Mozilla Firefox prompt will always be shown
        e.preventDefault();
        // Chrome requires returnValue to be set
        e.returnValue = '';
      }
    },
    [confirmationRequired, ignoreDirty],
  );

  React.useEffect(() => {
    window.addEventListener('beforeunload', confirmReload);
    return () => window.removeEventListener('beforeunload', confirmReload);
  }, [confirmReload]);
};
